export default "__VITE_ASSET__0_zAhPA___"